module.exports = __webpack_public_path__ + "img/6.b9fcf1b4.jpg";